import { useForm } from 'react-hook-form';

import {
  type DepartmentType,
  type InterviewQuestionRequest,
  type InterviewSettings,
  type InterviewType,
  QuestionType,
} from '@/services/api';

export const formatRecordingSize = (size: number) => {
  const fileSizeInKB = size / 1024; // Convert to KB
  const fileSizeInMB = size / (1024 * 1024); // Convert to MB

  if (fileSizeInMB >= 1) {
    return `${fileSizeInMB.toFixed(1)} MB`;
  }
  return `${fileSizeInKB.toFixed(1)} KB`;
};

export interface InterviewQuestionFormFields
  extends Omit<InterviewQuestionRequest, 'questions'> {
  questionMarkdown?: string;
  questions?: string;
  file?: File | undefined;
  isAiGenerated?: boolean;
}

export type NewInterviewFormInputs = {
  title?: string;
  startDate: Date;
  startTime: string;
  endDate: Date;
  endTime: string;
  informationalText?: string;
  questions?: Array<InterviewQuestionFormFields>;
  isLanguageTest?: boolean;
  type: InterviewType;
  language?: string;
  department: DepartmentType;
  interviewSettings: InterviewSettings;
};

const now = new Date();
const nextWeek = new Date(now);
nextWeek.setDate(nextWeek.getDate() + 7);

const formatTime = (date: Date) => {
  const hours = String(date.getHours()).padStart(2, '0');
  let minutes = String(Math.round(date.getMinutes() / 15) * 15).padStart(
    2,
    '0'
  );

  if (minutes === '60') {
    minutes = '00';
  }

  return hours + ':' + minutes;
};

export const useNewInterviewForm = () => {
  return useForm<NewInterviewFormInputs>({
    mode: 'onTouched',
    defaultValues: {
      questions: [{}],
      title: '',
      informationalText: '',
      startDate: now,
      startTime: formatTime(now),
      endDate: nextWeek,
      endTime: formatTime(now),
    },
  });
};

export type NewInterviewFormStepProps = {
  isActive?: boolean;
};

export const defaultQuestion: InterviewQuestionFormFields = {
  question: '',
  questionMarkdown: '',
  questionType: QuestionType.Video,
};
